export const authConfig = window.env?.auth;
